/** Link público «Adicionar ao Google Calendar» (template URL). */
export function buildGoogleCalendarTemplateLink(opts: {
  title: string
  data: string
  hora: string
  details?: string
  durationMin?: number
}): string {
  const durationMin = opts.durationMin ?? 60
  const [y, m, d] = opts.data.split('-').map(Number)
  const hm = opts.hora.trim().match(/^(\d{1,2}):(\d{2})/)
  const hh = hm ? Number(hm[1]) : 9
  const mm = hm ? Number(hm[2]) : 0
  const start = new Date(y, m - 1, d, hh, mm, 0)
  const end = new Date(start.getTime() + durationMin * 60_000)
  const fmt = (dt: Date) => {
    const pad = (n: number) => String(n).padStart(2, '0')
    return `${dt.getFullYear()}${pad(dt.getMonth() + 1)}${pad(dt.getDate())}T${pad(dt.getHours())}${pad(dt.getMinutes())}00`
  }
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: opts.title,
    dates: `${fmt(start)}/${fmt(end)}`,
    details: opts.details || '',
    ctz: 'Europe/Lisbon',
  })
  return `https://calendar.google.com/calendar/render?${params.toString()}`
}
